import React, { Component } from 'react'
import { Tooltip } from 'react-tippy'
import 'react-tippy/dist/tippy.css'

class Tip extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    const { children, ...props } = this.props

    if (this.state.hasError) {
      return children
    }

    return <Tooltip {...props}>{children}</Tooltip>
  }
}

export default Tip



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js